import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "4494cf0e-f672-44de-8353-dbe4b03d37ef",
  publicId: "8",
  name: "Acoustic elements - absorbers",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, task01],
};

export default lesson;
